import { render, staticRenderFns } from "./CreateProduk.vue?vue&type=template&id=6aa8b3de&scoped=true"
import script from "./CreateProduk.vue?vue&type=script&lang=js"
export * from "./CreateProduk.vue?vue&type=script&lang=js"
import style0 from "./CreateProduk.vue?vue&type=style&index=0&id=6aa8b3de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8b3de",
  null
  
)

export default component.exports